import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const projectDiscovery = defineConnector({
  identifier: "projectDiscovery",
  name: "ProjectDiscovery Cloud",
  tagLine: "Vulnerability scanning service",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.projectdiscovery\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [ProjectDiscovery Cloud](https://cloud.projectdiscovery.io/) and navigate to **Settings > API** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.projectdiscovery.io/v1/user",
  },
});
